import React from "react";
import Header from "../shared/header";
import { Box } from "@mui/material";

/**
 * A component that displays the template page header.
 * Features include:
 * - Page title
 * - Welcome subtitle in German
 * - Responsive layout
 * - Consistent styling with other pages
 * 
 * @component
 * @returns {JSX.Element} The rendered template page header
 * 
 * @example
 * ```tsx
 * <TemplatePage />
 * ```
 */
const TemplatePage = () => {
  return (
    <Box ml="20px" mt="65px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="VORLAGE" subtitle="Willkommen bei Ihren Vorlagen" />
      </Box>
    </Box>
  );
};

export default TemplatePage;
